import { enumIncludes } from "../../utils/type.utils";

import { BasicResourceType } from "./resources.enums";
import { TResourceType } from "./resources.types";
import { resourceTypesMap } from "./resources.maps";

export const getResourceBasicType = (resourceType: TResourceType): BasicResourceType | undefined =>
  Object.values(BasicResourceType).find((basicType) => isResourceType(basicType, resourceType));

export const isResourceType = (
  basicResourceType: BasicResourceType,
  resourceType: TResourceType
): boolean =>
  resourceType === basicResourceType ||
  enumIncludes(resourceTypesMap[basicResourceType] ?? {}, resourceType);
